import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, CssBaseline, ThemeProvider, createTheme, Typography } from '@mui/material'

import { loadFilters, loadData } from './actions/dataIntegrityActions'
import {
  selectSelectedTable, selectSelectedType,
  selectSelectedSides, selectSelectedVendors,
  selectDateFrom, selectDateTo, selectMedianWindow,
  selectRows,
} from './reducers/dataIntegrityReducer'
import DataIntegrityFilterBar from './components/filters/DataIntegrityFilterBar'
import DataIntegrityView      from './components/DataIntegrityView'

const theme = createTheme({
  palette: {
    primary:    { main: '#1565c0' },
    background: { default: '#f0f2f5', paper: '#ffffff' },
    divider:    '#e3e8ef',
    text: {
      primary:   '#1a2233',
      secondary: '#4a5568',
      disabled:  '#8fa3bc',
    },
  },
  typography: { fontFamily: "'IBM Plex Sans', 'Roboto', sans-serif" },
  components: {
    MuiPaper:         { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiOutlinedInput: { styleOverrides: { root: { fontSize: 13 } } },
    MuiInputLabel:    { styleOverrides: { root: { fontSize: 13 } } },
    MuiMenuItem:      { styleOverrides: { root: { fontSize: 13 } } },
  },
})

function DataIntegrityApp() {
  const dispatch        = useDispatch()
  const rows            = useSelector(selectRows)
  const selectedTable   = useSelector(selectSelectedTable)
  const selectedType    = useSelector(selectSelectedType)
  const selectedSides   = useSelector(selectSelectedSides)
  const selectedVendors = useSelector(selectSelectedVendors)
  const dateFrom        = useSelector(selectDateFrom)
  const dateTo          = useSelector(selectDateTo)
  const medianWindow    = useSelector(selectMedianWindow)

  useEffect(() => {
    if (!rows.length) {
      // First visit — load filters first (they trigger default data load)
      dispatch(loadFilters())
    } else {
      // Returning visit — force refresh with current filters
      dispatch(loadData({
        tableFilter:  selectedTable,
        type:         selectedType === 'both' ? null : selectedType,
        sides:        selectedSides.length   ? selectedSides   : null,
        vendors:      selectedVendors.length ? selectedVendors : null,
        dateFrom,
        dateTo,
        medianWindow,
      }))
    }
  }, [dispatch]) // eslint-disable-line

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', bgcolor: 'background.default', minHeight: 'calc(100vh - 130px)' }}>

        <Box sx={{ px: 2.5, py: 1, bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Typography variant="subtitle1" fontWeight={500} color="text.primary">
            Data Integrity — Health Monitor
          </Typography>
        </Box>

        <DataIntegrityFilterBar />

        <Box sx={{ flex: 1, p: '16px 20px', overflowY: 'auto' }}>
          <DataIntegrityView />
        </Box>

      </Box>
    </ThemeProvider>
  )
}

const DataIntegrity = () => <DataIntegrityApp />
export default DataIntegrity